
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#fff","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"transform":"translate(4.244 4.166)","fill":"inherit"}},[_c('rect',{attrs:{"width":"21.437","height":"1.191","rx":".5","transform":"rotate(45 .421 1.016)"}}),_c('rect',{attrs:{"width":"21.437","height":"1.191","rx":".5","transform":"rotate(-45 18.297 7.579)"}})])])
          )
        }
      }
    